import React, { useState, useEffect } from 'react';
import { Input, Form, Button, Icon } from 'antd';
import { shutdownFiltersData } from '../../../../shared/constants';
import { isInteger } from '../../../../shared/lib/filterValidators';
import { useSearchParams } from '../../../../shared/lib/searchParams';
import styles from './SearchField.module.scss';

const { Search } = Input;
const { Item: FormItem } = Form;
const {
  filters: { search },
} = shutdownFiltersData;

const SearchField = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const searchValue = searchParams.get(search.name);

  const [value, setValue] = useState(searchValue);

  const handleSearch = (value) => {
    const newParams = new URLSearchParams(searchParams);
    const trimValue = value?.trim();

    Boolean(trimValue)
      ? newParams.set(search.name, trimValue)
      : newParams.delete(search.name);
    setSearchParams(newParams);
  };

  useEffect(() => {
    if (searchValue !== value) setValue(searchValue);
  }, [searchValue]);

  const hasError = Boolean(value?.trim()) && !isInteger(value);

  return (
    <FormItem
      className={styles.root}
      help={hasError ? 'Некорректный номер' : ''}
      validateStatus={hasError ? 'error' : 'validating'}
    >
      <Search
        placeholder="Найти отключение по номеру"
        value={value || ''}
        onChange={(e) => setValue(e.target.value)}
        onSearch={handleSearch}
        enterButton={
          <Button
            className={styles.enterBtn}
            type="primary"
            disabled={hasError}
          >
            <Icon type="search" />
          </Button>
        }
      />
    </FormItem>
  );
};

export default SearchField;
